/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import CISAccordionItem from '../components/CIS/CIS-Accordion-Item';
import CISAccordionWithImageItemChild from '../components/CIS/CIS-Accordion-With-Image-Item-Child';
import CISAccordionWithImageItem from '../components/CIS/CIS-Accordion-With-Image-Item';
import CISAccordionWithImage from '../components/CIS/CIS-Accordion-With-Image';
import CISAccordion from '../components/CIS/CIS-Accordion';
import CISAlertSecondary from '../components/CIS/CIS-Alert-Secondary';
import CISAlert from '../components/CIS/CIS-Alert';
import CISBanner from '../components/CIS/CIS-Banner';
import CISBenchmarkCISCATPro from '../components/CIS/CIS-Benchmark-CIS-CAT-Pro';
import CISBlockquoteBlueBox from '../components/CIS/CIS-Blockquote-Blue-Box';
import CISBlockquoteCarouselItem from '../components/CIS/CIS-Blockquote-Carousel-Item';
import CISBlockquoteCarousel from '../components/CIS/CIS-Blockquote-Carousel';
import CISBlockquote from '../components/CIS/CIS-Blockquote';
import CISBreadcrumb from '../components/CIS/CIS-Breadcrumb';
import CISCheckmarkTable from '../components/CIS/CIS-Checkmark-Table';
import CISContentBlockWithCTA from '../components/CIS/CIS-Content-Block-With-CTA';
import CISContentBlockWithLabel from '../components/CIS/CIS-Content-Block-With-Label';
import CISContentBlueBox from '../components/CIS/CIS-Content-Blue-Box';
import CISContentCard from '../components/CIS/CIS-Content-Card';
import CISContentCards from '../components/CIS/CIS-Content-Cards';
import CISContentCarouselItem from '../components/CIS/CIS-Content-Carousel-Item';
import CISContentCarousel from '../components/CIS/CIS-Content-Carousel';
import CISContentGrayBox from '../components/CIS/CIS-Content-Gray-Box';
import CISContentOneColumn from '../components/CIS/CIS-Content-One-Column';
import CISContentThreeColumn from '../components/CIS/CIS-Content-Three-Column';
import CISContentTwoColumn from '../components/CIS/CIS-Content-Two-Column';
import CISContentBlock from '../components/CIS/CIS-ContentBlock';
import CISCTACarouselItemCTA from '../components/CIS/CIS-CTA-Carousel-Item-CTA';
import CISCTACarouselItem from '../components/CIS/CIS-CTA-Carousel-Item';
import CISCTACarousel from '../components/CIS/CIS-CTA-Carousel';
import CISCTAPrimary from '../components/CIS/CIS-CTA-Primary';
import CISCTASecondary from '../components/CIS/CIS-CTA-Secondary';
import CISCTATertiary from '../components/CIS/CIS-CTA-Tertiary';
import CISCybersecurityTools from '../components/CIS/CIS-Cybersecurity-Tools';
import CISDropDownContentWithLinks from '../components/CIS/CIS-DropDown-ContentWithLinks';
import CISDropDownFullWidthLinks from '../components/CIS/CIS-DropDown-FullWidthLinks';
import CISDropDownFullWidthLinkSection from '../components/CIS/CIS-DropDown-FullWidthLinkSection';
import CISDropDownLinkSectionBordered from '../components/CIS/CIS-DropDown-LinkSection-Bordered';
import CISDropDownLinkSection from '../components/CIS/CIS-DropDown-LinkSection';
import CISDropDownLinkSectionWithBg from '../components/CIS/CIS-DropDown-LinkSectionWithBg';
import CISDropDownTwoColumn from '../components/CIS/CIS-DropDown-TwoColumn';
import CISFAQItemHeadline from '../components/CIS/CIS-FAQ-Item-Headline';
import CISFAQItem from '../components/CIS/CIS-FAQ-Item';
import CISFAQ from '../components/CIS/CIS-FAQ';
import CISFeaturedArticle from '../components/CIS/CIS-Featured-Article';
import CISFromTheBlog from '../components/CIS/CIS-From-The-Blog';
import CISGridItem from '../components/CIS/CIS-Grid-Item';
import CISGrid from '../components/CIS/CIS-Grid';
import CISHardenedImagesCloudProviderList from '../components/CIS/CIS-Hardened-Images-Cloud-Provider-List';
import CISHardenedImagesListColumnHeader from '../components/CIS/CIS-Hardened-Images-List-Column-Header';
import CISHardenedImagesList from '../components/CIS/CIS-Hardened-Images-List';
import CISHeader from '../components/CIS/CIS-Header';
import CISHeaderUtilityLink from '../components/CIS/CIS-HeaderUtility-Link';
import CISHealthcareGraphicCard from '../components/CIS/CIS-Healthcare-Graphic-Card';
import CISHealthcareGraphicData from '../components/CIS/CIS-Healthcare-Graphic-Data';
import CISHealthcareGraphicFootnote from '../components/CIS/CIS-Healthcare-Graphic-Footnote';
import CISHealthcareGraphic from '../components/CIS/CIS-Healthcare-Graphic';
import CISHomeBlockquoteItem from '../components/CIS/CIS-Home-Blockquote-Item';
import CISHomeBlockquote from '../components/CIS/CIS-Home-Blockquote';
import CISHomeCardItem from '../components/CIS/CIS-Home-Card-Item';
import CISHomeCards from '../components/CIS/CIS-Home-Cards';
import CISHomeFeaturedCTA from '../components/CIS/CIS-Home-Featured-CTA';
import CISHomeHeroLayout from '../components/CIS/CIS-Home-HeroLayout';
import CISHomeIconContentItem from '../components/CIS/CIS-Home-Icon-Content-Item';
import CISHomeIconContent from '../components/CIS/CIS-Home-Icon-Content';
import CISHomeIndustry from '../components/CIS/CIS-Home-Industry';
import CISHomeMasthead from '../components/CIS/CIS-Home-Masthead';
import CISHomeUpdate from '../components/CIS/CIS-Home-Update';
import CISIconGroupItem from '../components/CIS/CIS-Icon-Group-Item';
import CISIconGroup from '../components/CIS/CIS-Icon-Group';
import CISImageCarouselItem from '../components/CIS/CIS-Image-Carousel-Item';
import CISImageCarousel from '../components/CIS/CIS-Image-Carousel';
import CISInfoHub from '../components/CIS/CIS-InfoHub';
import CISK12GraphicItem from '../components/CIS/CIS-K12-Graphic-Item';
import CISK12Graphic from '../components/CIS/CIS-K12-Graphic';
import CISListLandingFeatured from '../components/CIS/CIS-List-Landing-Featured';
import CISListLandingItem from '../components/CIS/CIS-List-Landing-Item';
import CISListLandingLink from '../components/CIS/CIS-List-Landing-Link';
import CISListLanding from '../components/CIS/CIS-List-Landing';
import CISListLinkExtraLinks from '../components/CIS/CIS-List-Link-Extra-Links';
import CISListLinkTitle from '../components/CIS/CIS-List-Link-Title';
import CISListLink from '../components/CIS/CIS-List-Link';
import CISListPageHero from '../components/CIS/CIS-List-Page-Hero';
import CISListPageLink from '../components/CIS/CIS-List-Page-Link';
import CISListPageRightRail from '../components/CIS/CIS-List-Page-Right-Rail';
import CISMastheadTwoColumnLink from '../components/CIS/CIS-Masthead-Two-Column-Link';
import CISMastheadTwoColumn from '../components/CIS/CIS-Masthead-Two-Column';
import CISMastheadWithLabel from '../components/CIS/CIS-Masthead-With-Label';
import CISMasthead from '../components/CIS/CIS-Masthead';
import CISMediaMasthead from '../components/CIS/CIS-Media-Masthead';
import CISMembers from '../components/CIS/CIS-Members';
import CISNavigationLink from '../components/CIS/CIS-Navigation-Link';
import CISPageTitle from '../components/CIS/CIS-PageTitle';
import CISPartnerLogoWallFilter from '../components/CIS/CIS-Partner-Logo-Wall-Filter';
import CISPartnerLogoWall from '../components/CIS/CIS-Partner-Logo-Wall';
import CISPartnersItem from '../components/CIS/CIS-Partners-Item';
import CISPartners from '../components/CIS/CIS-Partners';
import CISPriceSelector from '../components/CIS/CIS-Price-Selector';
import CISProfileListItem from '../components/CIS/CIS-Profile-List-Item';
import CISProfileList from '../components/CIS/CIS-Profile-List';
import CISProfile from '../components/CIS/CIS-Profile';
import CISResourceListSignUp from '../components/CIS/CIS-Resource-List-Sign-Up';
import CISRichText from '../components/CIS/CIS-RichText';
import CISSignUpModal from '../components/CIS/CIS-Sign-Up-Modal';
import CISStepsCarouselItem from '../components/CIS/CIS-Steps-Carousel-Item';
import CISStepsCarousel from '../components/CIS/CIS-Steps-Carousel';
import CISTabsSecondaryTab from '../components/CIS/CIS-Tabs-Secondary-Tab';
import CISTabsSecondary from '../components/CIS/CIS-Tabs-Secondary';
import CISTabsTab from '../components/CIS/CIS-Tabs-Tab';
import CISTabs from '../components/CIS/CIS-Tabs';
import CISUXExample from '../components/CIS/CIS-UX-Example';
import CISWistiaAudio from '../components/CIS/CIS-Wistia-Audio';
import CISWistiaVideo from '../components/CIS/CIS-Wistia-Video';
import CISControlsNavigatorExport from '../components/CIS/Controls-Navigator/CIS-Controls-Navigator-Export';
import CISControlsNavigatorIG from '../components/CIS/Controls-Navigator/CIS-Controls-Navigator-IG';
import CISControlsNavigatorListingControl from '../components/CIS/Controls-Navigator/CIS-Controls-Navigator-Listing-Control';
import CISControlsNavigatorListingSafeguard from '../components/CIS/Controls-Navigator/CIS-Controls-Navigator-Listing-Safeguard';
import CISControlsNavigatorListing from '../components/CIS/Controls-Navigator/CIS-Controls-Navigator-Listing';
import CISControlsNavigatorMappings from '../components/CIS/Controls-Navigator/CIS-Controls-Navigator-Mappings';
import CISControlsNavigatorSelector from '../components/CIS/Controls-Navigator/CIS-Controls-Navigator-Selector';
import CISControlsNavigator from '../components/CIS/Controls-Navigator/CIS-Controls-Navigator';
import CISControlsResourcesListing from '../components/CIS/Controls-Resources/CIS-Controls-Resources-Listing';
import CISControlsResourcesNav from '../components/CIS/Controls-Resources/CIS-Controls-Resources-Nav';
import CISControlsResources from '../components/CIS/Controls-Resources/CIS-Controls-Resources';
import CISFooterCopyright from '../components/CIS/Footer/CIS-Footer-Copyright';
import CISFooterNavListLink from '../components/CIS/Footer/CIS-Footer-NavList-Link';
import CISFooterNavListSpacer from '../components/CIS/Footer/CIS-Footer-NavList-Spacer';
import CISFooterNavList from '../components/CIS/Footer/CIS-Footer-NavList';
import CISFooterSocialLink from '../components/CIS/Footer/CIS-Footer-SocialLink';
import CISFooterUtilityLink from '../components/CIS/Footer/CIS-Footer-UtilityLink';
import CISFooter from '../components/CIS/Footer/CIS-Footer';
import CISResourceAdvisoryAffectedSystem from '../components/CIS/Resources/CIS-Resource-Advisory-AffectedSystem';
import CISResourceAdvisoryReference from '../components/CIS/Resources/CIS-Resource-Advisory-Reference';
import CISResourceAdvisoryRelatedBenchmark from '../components/CIS/Resources/CIS-Resource-Advisory-RelatedBenchmark';
import CISResourceAdvisoryRelatedControl from '../components/CIS/Resources/CIS-Resource-Advisory-RelatedControl';
import CISResourceAdvisoryRiskCategory from '../components/CIS/Resources/CIS-Resource-Advisory-RiskCategory';
import CISResourceAdvisory from '../components/CIS/Resources/CIS-Resource-Advisory';
import CISResourceBenchmarkList from '../components/CIS/Resources/CIS-Resource-Benchmark-List';
import CISResourceBenchmark from '../components/CIS/Resources/CIS-Resource-Benchmark';
import CISResourceBlog from '../components/CIS/Resources/CIS-Resource-Blog';
import CISResourceCaseStudy from '../components/CIS/Resources/CIS-Resource-CaseStudy';
import CISResourceGenericPage from '../components/CIS/Resources/CIS-Resource-GenericPage';
import CISResourceMediaMention from '../components/CIS/Resources/CIS-Resource-Media-Mention';
import CISResourceNewsletter from '../components/CIS/Resources/CIS-Resource-Newsletter';
import CISResourcePagedListingBadge from '../components/CIS/Resources/CIS-Resource-PagedListing-Badge';
import CISResourcePagedListingBenchmarkExcerpt from '../components/CIS/Resources/CIS-Resource-PagedListing-BenchmarkExcerpt';
import CISResourcePagedListingDate from '../components/CIS/Resources/CIS-Resource-PagedListing-Date';
import CISResourcePagedListingExcerpt from '../components/CIS/Resources/CIS-Resource-PagedListing-Excerpt';
import CISResourcePagedListingFilter from '../components/CIS/Resources/CIS-Resource-PagedListing-Filter';
import CISResourcePagedListingImage from '../components/CIS/Resources/CIS-Resource-PagedListing-Image';
import CISResourcePagedListingItems from '../components/CIS/Resources/CIS-Resource-PagedListing-Items';
import CISResourcePagedListingNewsletter from '../components/CIS/Resources/CIS-Resource-PagedListing-Newsletter';
import CISResourcePagedListingPageInfo from '../components/CIS/Resources/CIS-Resource-PagedListing-PageInfo';
import CISResourcePagedListingPagination from '../components/CIS/Resources/CIS-Resource-PagedListing-Pagination';
import CISResourcePagedListingWebinar from '../components/CIS/Resources/CIS-Resource-PagedListing-Webinar';
import CISResourcePagedListing from '../components/CIS/Resources/CIS-Resource-PagedListing';
import CISResourcePartner from '../components/CIS/Resources/CIS-Resource-Partner';
import CISResourcePartnerListing from '../components/CIS/Resources/CIS-Resource-PartnerListing';
import CISResourcePodcast from '../components/CIS/Resources/CIS-Resource-Podcast';
import CISResourcePressRelease from '../components/CIS/Resources/CIS-Resource-Press-Release';
import CISResourceSpotlight from '../components/CIS/Resources/CIS-Resource-Spotlight';
import CISResourceWebinar from '../components/CIS/Resources/CIS-Resource-Webinar';
import CISResourceWhitePaper from '../components/CIS/Resources/CIS-Resource-White-Paper';
import CISResourceBlogData from '../components/CIS/Resources/CIS-ResourceBlogData';
import CISResourceByLine from '../components/CIS/Resources/CIS-ResourceByLine';
import CISResourceContent from '../components/CIS/Resources/CIS-ResourceContent';
import CISResourceCTA from '../components/CIS/Resources/CIS-ResourceCTA';
import CISResourceDownloadFile from '../components/CIS/Resources/CIS-ResourceDownloadFile';
import CISResourceDownloads from '../components/CIS/Resources/CIS-ResourceDownloads';
import CISResourceExcerpt from '../components/CIS/Resources/CIS-ResourceExcerpt';
import CISResourceHeading from '../components/CIS/Resources/CIS-ResourceHeading';
import CISResourcePublishedDate from '../components/CIS/Resources/CIS-ResourcePublishedDate';
import CISResourceRelatedResources from '../components/CIS/Resources/CIS-ResourceRelatedResources';
import CISResourceRightColumnContent from '../components/CIS/Resources/CIS-ResourceRightColumnContent';
import CISResourceTaxonomies from '../components/CIS/Resources/CIS-ResourceTaxonomies';
import CISTaxonomyItems from '../components/CIS/Resources/CIS-TaxonomyItems';
import CIS_ResourceBenchmarkDocument from '../components/CIS/Resources/CIS_Resource-Benchmark-Document';
import CIS_ResourceBenchmarkImage from '../components/CIS/Resources/CIS_Resource-Benchmark-Image';
import CIS_ResourceBenchmarkRemediationKit from '../components/CIS/Resources/CIS_Resource-Benchmark-RemediationKit';
import CIS_ResourceBenchmarkVersion from '../components/CIS/Resources/CIS_Resource-Benchmark-Version';
import CISSearch from '../components/CIS/Search/CIS-Search';
import CISStructuredDataWebsite from '../components/CIS/StructuredData/CIS-StructuredData-Website';
import CISCarouselSlide from '../components/CIS-Carousel-Slide';
import CISCarousel from '../components/CIS-Carousel';
import CISLatestAdvisory from '../components/CIS-Latest-Advisory';
import CISLatestAlert from '../components/CIS-Latest-Alert';
import CISLatestInsightsItemStatic from '../components/CIS-Latest-Insights-Item-Static';
import CISLatestInsightsItem from '../components/CIS-Latest-Insights-Item';
import CISLatestInsights from '../components/CIS-Latest-Insights';
import CISLatestSpotlight from '../components/CIS-Latest-Spotlight';
import JSONViewer from '../components/JSON-Viewer';
import PartialDesignDynamicPlaceholder from '../components/PartialDesignDynamicPlaceholder';
import TestTracker from '../components/Test-Tracker';

const components = new Map();
components.set('CIS-Accordion-Item', CISAccordionItem);
components.set('CIS-Accordion-With-Image-Item-Child', CISAccordionWithImageItemChild);
components.set('CIS-Accordion-With-Image-Item', CISAccordionWithImageItem);
components.set('CIS-Accordion-With-Image', CISAccordionWithImage);
components.set('CIS-Accordion', CISAccordion);
components.set('CIS-Alert-Secondary', CISAlertSecondary);
components.set('CIS-Alert', CISAlert);
components.set('CIS-Banner', CISBanner);
components.set('CIS-Benchmark-CIS-CAT-Pro', CISBenchmarkCISCATPro);
components.set('CIS-Blockquote-Blue-Box', CISBlockquoteBlueBox);
components.set('CIS-Blockquote-Carousel-Item', CISBlockquoteCarouselItem);
components.set('CIS-Blockquote-Carousel', CISBlockquoteCarousel);
components.set('CIS-Blockquote', CISBlockquote);
components.set('CIS-Breadcrumb', CISBreadcrumb);
components.set('CIS-Checkmark-Table', CISCheckmarkTable);
components.set('CIS-Content-Block-With-CTA', CISContentBlockWithCTA);
components.set('CIS-Content-Block-With-Label', CISContentBlockWithLabel);
components.set('CIS-Content-Blue-Box', CISContentBlueBox);
components.set('CIS-Content-Card', CISContentCard);
components.set('CIS-Content-Cards', CISContentCards);
components.set('CIS-Content-Carousel-Item', CISContentCarouselItem);
components.set('CIS-Content-Carousel', CISContentCarousel);
components.set('CIS-Content-Gray-Box', CISContentGrayBox);
components.set('CIS-Content-One-Column', CISContentOneColumn);
components.set('CIS-Content-Three-Column', CISContentThreeColumn);
components.set('CIS-Content-Two-Column', CISContentTwoColumn);
components.set('CIS-ContentBlock', CISContentBlock);
components.set('CIS-CTA-Carousel-Item-CTA', CISCTACarouselItemCTA);
components.set('CIS-CTA-Carousel-Item', CISCTACarouselItem);
components.set('CIS-CTA-Carousel', CISCTACarousel);
components.set('CIS-CTA-Primary', CISCTAPrimary);
components.set('CIS-CTA-Secondary', CISCTASecondary);
components.set('CIS-CTA-Tertiary', CISCTATertiary);
components.set('CIS-Cybersecurity-Tools', CISCybersecurityTools);
components.set('CIS-DropDown-ContentWithLinks', CISDropDownContentWithLinks);
components.set('CIS-DropDown-FullWidthLinks', CISDropDownFullWidthLinks);
components.set('CIS-DropDown-FullWidthLinkSection', CISDropDownFullWidthLinkSection);
components.set('CIS-DropDown-LinkSection-Bordered', CISDropDownLinkSectionBordered);
components.set('CIS-DropDown-LinkSection', CISDropDownLinkSection);
components.set('CIS-DropDown-LinkSectionWithBg', CISDropDownLinkSectionWithBg);
components.set('CIS-DropDown-TwoColumn', CISDropDownTwoColumn);
components.set('CIS-FAQ-Item-Headline', CISFAQItemHeadline);
components.set('CIS-FAQ-Item', CISFAQItem);
components.set('CIS-FAQ', CISFAQ);
components.set('CIS-Featured-Article', CISFeaturedArticle);
components.set('CIS-From-The-Blog', CISFromTheBlog);
components.set('CIS-Grid-Item', CISGridItem);
components.set('CIS-Grid', CISGrid);
components.set('CIS-Hardened-Images-Cloud-Provider-List', CISHardenedImagesCloudProviderList);
components.set('CIS-Hardened-Images-List-Column-Header', CISHardenedImagesListColumnHeader);
components.set('CIS-Hardened-Images-List', CISHardenedImagesList);
components.set('CIS-Header', CISHeader);
components.set('CIS-HeaderUtility-Link', CISHeaderUtilityLink);
components.set('CIS-Healthcare-Graphic-Card', CISHealthcareGraphicCard);
components.set('CIS-Healthcare-Graphic-Data', CISHealthcareGraphicData);
components.set('CIS-Healthcare-Graphic-Footnote', CISHealthcareGraphicFootnote);
components.set('CIS-Healthcare-Graphic', CISHealthcareGraphic);
components.set('CIS-Home-Blockquote-Item', CISHomeBlockquoteItem);
components.set('CIS-Home-Blockquote', CISHomeBlockquote);
components.set('CIS-Home-Card-Item', CISHomeCardItem);
components.set('CIS-Home-Cards', CISHomeCards);
components.set('CIS-Home-Featured-CTA', CISHomeFeaturedCTA);
components.set('CIS-Home-HeroLayout', CISHomeHeroLayout);
components.set('CIS-Home-Icon-Content-Item', CISHomeIconContentItem);
components.set('CIS-Home-Icon-Content', CISHomeIconContent);
components.set('CIS-Home-Industry', CISHomeIndustry);
components.set('CIS-Home-Masthead', CISHomeMasthead);
components.set('CIS-Home-Update', CISHomeUpdate);
components.set('CIS-Icon-Group-Item', CISIconGroupItem);
components.set('CIS-Icon-Group', CISIconGroup);
components.set('CIS-Image-Carousel-Item', CISImageCarouselItem);
components.set('CIS-Image-Carousel', CISImageCarousel);
components.set('CIS-InfoHub', CISInfoHub);
components.set('CIS-K12-Graphic-Item', CISK12GraphicItem);
components.set('CIS-K12-Graphic', CISK12Graphic);
components.set('CIS-List-Landing-Featured', CISListLandingFeatured);
components.set('CIS-List-Landing-Item', CISListLandingItem);
components.set('CIS-List-Landing-Link', CISListLandingLink);
components.set('CIS-List-Landing', CISListLanding);
components.set('CIS-List-Link-Extra-Links', CISListLinkExtraLinks);
components.set('CIS-List-Link-Title', CISListLinkTitle);
components.set('CIS-List-Link', CISListLink);
components.set('CIS-List-Page-Hero', CISListPageHero);
components.set('CIS-List-Page-Link', CISListPageLink);
components.set('CIS-List-Page-Right-Rail', CISListPageRightRail);
components.set('CIS-Masthead-Two-Column-Link', CISMastheadTwoColumnLink);
components.set('CIS-Masthead-Two-Column', CISMastheadTwoColumn);
components.set('CIS-Masthead-With-Label', CISMastheadWithLabel);
components.set('CIS-Masthead', CISMasthead);
components.set('CIS-Media-Masthead', CISMediaMasthead);
components.set('CIS-Members', CISMembers);
components.set('CIS-Navigation-Link', CISNavigationLink);
components.set('CIS-PageTitle', CISPageTitle);
components.set('CIS-Partner-Logo-Wall-Filter', CISPartnerLogoWallFilter);
components.set('CIS-Partner-Logo-Wall', CISPartnerLogoWall);
components.set('CIS-Partners-Item', CISPartnersItem);
components.set('CIS-Partners', CISPartners);
components.set('CIS-Price-Selector', CISPriceSelector);
components.set('CIS-Profile-List-Item', CISProfileListItem);
components.set('CIS-Profile-List', CISProfileList);
components.set('CIS-Profile', CISProfile);
components.set('CIS-Resource-List-Sign-Up', CISResourceListSignUp);
components.set('CIS-RichText', CISRichText);
components.set('CIS-Sign-Up-Modal', CISSignUpModal);
components.set('CIS-Steps-Carousel-Item', CISStepsCarouselItem);
components.set('CIS-Steps-Carousel', CISStepsCarousel);
components.set('CIS-Tabs-Secondary-Tab', CISTabsSecondaryTab);
components.set('CIS-Tabs-Secondary', CISTabsSecondary);
components.set('CIS-Tabs-Tab', CISTabsTab);
components.set('CIS-Tabs', CISTabs);
components.set('CIS-UX-Example', CISUXExample);
components.set('CIS-Wistia-Audio', CISWistiaAudio);
components.set('CIS-Wistia-Video', CISWistiaVideo);
components.set('CIS-Controls-Navigator-Export', CISControlsNavigatorExport);
components.set('CIS-Controls-Navigator-IG', CISControlsNavigatorIG);
components.set('CIS-Controls-Navigator-Listing-Control', CISControlsNavigatorListingControl);
components.set('CIS-Controls-Navigator-Listing-Safeguard', CISControlsNavigatorListingSafeguard);
components.set('CIS-Controls-Navigator-Listing', CISControlsNavigatorListing);
components.set('CIS-Controls-Navigator-Mappings', CISControlsNavigatorMappings);
components.set('CIS-Controls-Navigator-Selector', CISControlsNavigatorSelector);
components.set('CIS-Controls-Navigator', CISControlsNavigator);
components.set('CIS-Controls-Resources-Listing', CISControlsResourcesListing);
components.set('CIS-Controls-Resources-Nav', CISControlsResourcesNav);
components.set('CIS-Controls-Resources', CISControlsResources);
components.set('CIS-Footer-Copyright', CISFooterCopyright);
components.set('CIS-Footer-NavList-Link', CISFooterNavListLink);
components.set('CIS-Footer-NavList-Spacer', CISFooterNavListSpacer);
components.set('CIS-Footer-NavList', CISFooterNavList);
components.set('CIS-Footer-SocialLink', CISFooterSocialLink);
components.set('CIS-Footer-UtilityLink', CISFooterUtilityLink);
components.set('CIS-Footer', CISFooter);
components.set('CIS-Resource-Advisory-AffectedSystem', CISResourceAdvisoryAffectedSystem);
components.set('CIS-Resource-Advisory-Reference', CISResourceAdvisoryReference);
components.set('CIS-Resource-Advisory-RelatedBenchmark', CISResourceAdvisoryRelatedBenchmark);
components.set('CIS-Resource-Advisory-RelatedControl', CISResourceAdvisoryRelatedControl);
components.set('CIS-Resource-Advisory-RiskCategory', CISResourceAdvisoryRiskCategory);
components.set('CIS-Resource-Advisory', CISResourceAdvisory);
components.set('CIS-Resource-Benchmark-List', CISResourceBenchmarkList);
components.set('CIS-Resource-Benchmark', CISResourceBenchmark);
components.set('CIS-Resource-Blog', CISResourceBlog);
components.set('CIS-Resource-CaseStudy', CISResourceCaseStudy);
components.set('CIS-Resource-GenericPage', CISResourceGenericPage);
components.set('CIS-Resource-Media-Mention', CISResourceMediaMention);
components.set('CIS-Resource-Newsletter', CISResourceNewsletter);
components.set('CIS-Resource-PagedListing-Badge', CISResourcePagedListingBadge);
components.set('CIS-Resource-PagedListing-BenchmarkExcerpt', CISResourcePagedListingBenchmarkExcerpt);
components.set('CIS-Resource-PagedListing-Date', CISResourcePagedListingDate);
components.set('CIS-Resource-PagedListing-Excerpt', CISResourcePagedListingExcerpt);
components.set('CIS-Resource-PagedListing-Filter', CISResourcePagedListingFilter);
components.set('CIS-Resource-PagedListing-Image', CISResourcePagedListingImage);
components.set('CIS-Resource-PagedListing-Items', CISResourcePagedListingItems);
components.set('CIS-Resource-PagedListing-Newsletter', CISResourcePagedListingNewsletter);
components.set('CIS-Resource-PagedListing-PageInfo', CISResourcePagedListingPageInfo);
components.set('CIS-Resource-PagedListing-Pagination', CISResourcePagedListingPagination);
components.set('CIS-Resource-PagedListing-Webinar', CISResourcePagedListingWebinar);
components.set('CIS-Resource-PagedListing', CISResourcePagedListing);
components.set('CIS-Resource-Partner', CISResourcePartner);
components.set('CIS-Resource-PartnerListing', CISResourcePartnerListing);
components.set('CIS-Resource-Podcast', CISResourcePodcast);
components.set('CIS-Resource-Press-Release', CISResourcePressRelease);
components.set('CIS-Resource-Spotlight', CISResourceSpotlight);
components.set('CIS-Resource-Webinar', CISResourceWebinar);
components.set('CIS-Resource-White-Paper', CISResourceWhitePaper);
components.set('CIS-ResourceBlogData', CISResourceBlogData);
components.set('CIS-ResourceByLine', CISResourceByLine);
components.set('CIS-ResourceContent', CISResourceContent);
components.set('CIS-ResourceCTA', CISResourceCTA);
components.set('CIS-ResourceDownloadFile', CISResourceDownloadFile);
components.set('CIS-ResourceDownloads', CISResourceDownloads);
components.set('CIS-ResourceExcerpt', CISResourceExcerpt);
components.set('CIS-ResourceHeading', CISResourceHeading);
components.set('CIS-ResourcePublishedDate', CISResourcePublishedDate);
components.set('CIS-ResourceRelatedResources', CISResourceRelatedResources);
components.set('CIS-ResourceRightColumnContent', CISResourceRightColumnContent);
components.set('CIS-ResourceTaxonomies', CISResourceTaxonomies);
components.set('CIS-TaxonomyItems', CISTaxonomyItems);
components.set('CIS_Resource-Benchmark-Document', CIS_ResourceBenchmarkDocument);
components.set('CIS_Resource-Benchmark-Image', CIS_ResourceBenchmarkImage);
components.set('CIS_Resource-Benchmark-RemediationKit', CIS_ResourceBenchmarkRemediationKit);
components.set('CIS_Resource-Benchmark-Version', CIS_ResourceBenchmarkVersion);
components.set('CIS-Search', CISSearch);
components.set('CIS-StructuredData-Website', CISStructuredDataWebsite);
components.set('CIS-Carousel-Slide', CISCarouselSlide);
components.set('CIS-Carousel', CISCarousel);
components.set('CIS-Latest-Advisory', CISLatestAdvisory);
components.set('CIS-Latest-Alert', CISLatestAlert);
components.set('CIS-Latest-Insights-Item-Static', CISLatestInsightsItemStatic);
components.set('CIS-Latest-Insights-Item', CISLatestInsightsItem);
components.set('CIS-Latest-Insights', CISLatestInsights);
components.set('CIS-Latest-Spotlight', CISLatestSpotlight);
components.set('JSON-Viewer', JSONViewer);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('Test-Tracker', TestTracker);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
